import script from "./IVRConfigComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./IVRConfigComponent.vue?vue&type=script&setup=true&lang=js"

import "./IVRConfigComponent.vue?vue&type=style&index=0&id=813b8302&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-813b8302"]])

export default __exports__